import script from "./EmailComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmailComponent.vue?vue&type=script&lang=ts&setup=true"

import "./EmailComponent.vue?vue&type=style&index=0&id=d3b42b7e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3b42b7e"]])

export default __exports__